import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Size extends Component {
    static propTypes = {
        targetUnit: PropTypes.oneOf(['Gb', 'Mb', 'Kb', 'b']),
        currentUnit: PropTypes.oneOf(['Gb', 'Mb', 'Kb', 'b']),
        children: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ])
    };
    static defaultProps = {
        targetUnit: 'Mb',
        currentUnit: 'b'
    };
    state = {};

    render() {
        const value = parseInt(this.props.children) || 0;
        const targetValue = (value / 1024.0 / 1024.0).toFixed(1).toString().replace(/\.0$/, '');

        return `${targetValue} ${this.props.targetUnit}`;
    }
}

export default Size;


// WEBPACK FOOTER //
// ./src/formatters/Size.js